<div class="d-flex flex-column vh-100">
  <app-navbar></app-navbar>
  <div class="content flex-grow-1 justify-content-center">
    <div class="error-wrapper h-100 text-center">
      <p class="xxl-text d-inline">{{ errorDetail.errorCode | translate }}</p>
      <ix-typography class="mb-2" format="display-xl">{{
          errorDetail.errorHeader | translate
        }}
      </ix-typography>
      <ix-typography class="mb-4" format="body">{{
          errorDetail.errorDescription | translate
        }}
      </ix-typography>
      <ix-button [routerLink]="'/login'" variant="primary">{{
          'general.login' | translate
        }}
      </ix-button>
    </div>
  </div>
  <app-footer></app-footer>
</div>
